<script setup lang="ts"></script>

<template>
    <section class="my-2_5rem ktg-main-container">
        <h2 class="ktg-title-02 mb-2rem">{{ $t('kontakt') }}</h2>
        <div class="ktg-body-lead">{{ $t('keine_passende_antwort_gefunden') }}</div>
        <div class="ktg-body" v-html="$t('eplan_kontakt_text')"></div>
    </section>
</template>

<style scoped></style>
